module.exports = __webpack_public_path__ + "materialdesignicons-webfont.woff?4b882ad484d11b49f4a69212ad8e8901";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.woff?v=2.8.94
// module id = 1531
// module chunks = 0